import React from 'react';
import { Outlet } from 'react-router-dom';

const CandidateLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-white overflow-auto">
      <main className="w-full max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <Outlet />
      </main>
    </div>
  );
};

export default CandidateLayout;
